<template>
  <div>
    <section style="max-height: 80vh; overflow-y: scroll">
      <table class="table align-middle table-bordered table-hover">
        <thead class="table-primary">
          <tr class="text-capitalize">
            <th>topic</th>
            <th>date</th>
            <th>message</th>
            <th>owner</th>
            <th>related</th>
            <th>status</th>
            <th>Edit</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(message, index) in messages" :key="index">
            <td class="text-body">
                <router-link
                :to="{ name: 'Room', params: { id: message.room.uid } }"
                custom
                v-slot="{ navigate }"
              >
                <span
                  role="link"
                  class="btn btn-link"
                  title="Go to the Topic"
                  @click="navigate"
                  aria-current="true"
                  @keypress.enter="navigate"
                >
                    {{ message.room.title }}
                </span>
              </router-link>
            </td>
            <td class="text-body">
              {{ message.created_at }}
            </td>
            <td class="text-body">
              {{ $store.state.utils.filters.stringLimit(message.message, 100) }}
            </td>
            <td class="text-body">
              {{ message.owner.username }}
            </td>
            <td class="text-body">
              {{ message.related.message }}
            </td>
            <td class="text-body">
              <span v-if="message.status == 1">Enabled</span>
              <span v-else>Disabled</span>
            </td>
            <td class="text-body">
              <button
                @click="setCurrentMessage(message)"
                data-bs-toggle="modal"
                data-bs-target="#currentMessage"
                class="btn btn-link"
              >
                <i class="fa-solid fa-pen-to-square"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
    <nav aria-label="Page navigation text-end">
      <ul class="pagination" style="justify-content: flex-end">
        <li class="page-item">
          <button
            v-if="lastindexPost >= perPage"
            class="btn page-link"
            @click="loadMessages(false)"
          >
            Previous
          </button>
          <button v-else class="btn page-link disabled" disabled>
            Previous
          </button>
        </li>

        <li v-for="i in countOfPages" :key="i" class="page-item">
          <span
            class="page-link"
            v-bind:class="currentPage == i - 1 ? 'text-danger' : false"
            @click="loadMessages(i)"
            >{{ i }}</span
          >
        </li>

        <li class="page-item">
          <button
            v-if="countOfPages > currentPage"
            @click="loadMessages(true)"
            class="btn page-link"
          >
            Next
          </button>
          <button v-else class="btn page-link disabled" disabled>Next</button>
        </li>
      </ul>
    </nav>

    <div
      class="modal fade"
      id="currentMessage"
      tabindex="-1"
      aria-labelledby="currentMessageLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div v-if="currnetMessage" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="currentMessageLabel">
              {{ currnetMessage.name }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="status" class="form-label">Status</label>
              <select
                class="form-select"
                v-model="status"
                aria-label="Default select example"
              >
                <option value="0">Disabled</option>
                <option value="1">Enabled</option>
              </select>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-link" data-bs-dismiss="modal">
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
            >
              <span @click="changeMessageStatus">Yes</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminMessages",

  data() {
    return {
      messages: [],
      status: undefined,
      lastindexPost: 0,
      currentPage: 1,
      perPage: 10,
      countOfPages: 0,
      currnetMessage: undefined,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.loadMessages(null);
    });
  },
  methods: {
    loadMessages(directive) {
      if (directive != null) {
        if (directive === true) {
          this.lastindexPost += this.perPage;
          this.currentPage++;
        } else if (directive === false) {
          this.lastindexPost -= this.perPage;
          this.currentPage--;
        } else {
          --directive;
          this.lastindexPost = this.perPage * directive;
          this.currentPage = directive;
        }
      }

      this.$store.state.modules.api
        .getAllMessagesForAdmin(
          JSON.parse(localStorage.account).token,
          this.lastindexPost,
          this.perPage
        )
        .then((resp) => {
          this.messages = resp.data.messages;
          this.countOfPages = resp.data.countOfPages;
        });
    },

    setCurrentMessage(message) {
      this.currnetMessage = message;
      this.status = message.status;
    },

    changeMessageStatus() {
      this.$store.state.modules.api
        .changeMessageStatus(
          this.currnetMessage.uid,
          this.status,
          JSON.parse(localStorage.account).token
        )
        .then((resp) => {
          if (resp.status == 200) {
            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                message: "success deleted Post",
              },
              2500
            );
            this.loadMessages(null);
          } else {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                message: "warning Post",
              },
              2500
            );
          }
        });
    },
  },
};
</script>
